import { Component, OnInit } from '@angular/core';
import {GrupolojasService} from "../../superadmin/services/grupolojas.service";
import {PedidosService} from "../../services/pedidos.service";
import {ModalKendo} from "../../lib/ModalKendo";

@Component({
  selector: 'app-modal-uberdirectdetalhes',
  templateUrl: './modal-uberdirectdetalhes.component.html',
  styleUrls: ['./modal-uberdirectdetalhes.component.scss']
})
export class ModalUberdirectdetalhesComponent extends ModalKendo implements OnInit {
  pedido: any = {};
  notificacoes = [];
  carregando = true;
  constructor( private  grupolojasService: GrupolojasService,
              private  pedidosService: PedidosService) {
    super()
  }


  ngOnInit(): void {
    this.pedidosService.listeNotificacaoesUberDoPedido(this.pedido.id).then((notificacoes) => {
      this.carregando = false;
      this.notificacoes = notificacoes;
    }).catch((erro) => {
      this.carregando = false;
      alert(erro);
    })
  }



}
